export const VAPID_KEY =
  'BNByZ6qJFpQq78i2mDZqpcMDZ10LWo4XO0M-EQqa3M-LQQPLYlN3ssjNChcbkvp0mHgsjXSuKkke_pk3eDeN2Hg';

export const CONFIG_APP = {
  messagingSenderId: '297434594351',
  projectId: 'push-notification-bw-dea05',
  appId: '1:297434594351:web:88f88f5f33d48abe',
  apiKey: 'AIzaSyBDjZslZEbB7FbpTFe4UnZkX-DOK9resdc',
  storageBucket: 'push-notification-bw-dea05.appspot.com',
  authDomain: 'push-notification-bw-dea05.firebaseapp.com',
  databaseURL: 'https://push-notification-bw-dea05.firebaseio.com',
};
